import { useStore } from "vuex";
import useLegacyIdRedirect from "@/util/useLegacyIdRedirect.ts";

export default function useEntryRedirect() {
  const store = useStore();
  const { checkForLegacyIdAndRedirect } = useLegacyIdRedirect();

  function entryRedirect(to) {
    const { categoryID, entryID } = to.params;

    checkForLegacyIdAndRedirect(categoryID, entryID);

    const category = store.getters["api/category"](categoryID);

    const noPersonViewCategoryLayouts = [
      "PersonListCategoryLayout2",
      "PersonBannersLayout",
    ];

    if (
      !store.getters.isAuth &&
      noPersonViewCategoryLayouts.includes(category.layout)
    ) {
      // some categories do not provide a person view for their entries.
      // if not in CMS mode, we redirect back to the category.
      return {
        name: "Category",
        params: {
          styleid: store.getters.getStyleID,
          categoryID: to.params.categoryID,
        },
      };
    }

    return undefined;
  }

  return {
    entryRedirect,
  };
}
